export const SEAT_DETAILS='SEAT_DETAILS';
export const SELECTED_SSRS_SEAT_IDENTIFICATION = 'SELECTED_SSRS_SEAT_IDENTIFICATION';